
import React, { useEffect, useState } from 'react'
import { Button, Grid, Input } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import { useTranslation } from 'react-i18next';

import "./SearchPriceRangePicker.css"
import { SetMinPrice, SetMaxPrice, SetCurrencyRatio } from '../../../../redux/actions/mainActions';

const SearchPriceRangePicker = ({ }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const minPrice = useSelector((state) => state.main.minPrice)
  const maxPrice = useSelector((state) => state.main.maxPrice)
  const currencyRatio = useSelector((state) => state.main.currencyRatio)

  const marks = {
    0: '0میلیون تومان',

    100: {
      style: {
        color: 'red',
      },
      label: <strong>100میلیون تومان</strong>,
    },
  };

  const handlePriceRangeChange = (data) => {
    dispatch(SetMinPrice(data[0]))
    dispatch(SetMaxPrice(data[1]))
  }
  return <Grid centered verticalAlign="middle" className="position-absolute bg-white rounded-30 top-110 p-1 w-100" >
    <Grid.Column width={16}>
      <Input
        label={{ basic: true, content: currencyRatio}}
        labelPosition='right'
        placeholder="min"
        value={minPrice}
        fluid
        onChange={(e) => dispatch(SetMinPrice(e.target.value))}

      />
    </Grid.Column>

    <Grid.Column width={16}>
      <Input
        label={{ basic: true, content: currencyRatio}}
        labelPosition='right'
        placeholder='max'
        fluid
        value={maxPrice}
        onChange={(e) => dispatch(SetMaxPrice(e.target.value))}
      />
    </Grid.Column>





    <Grid.Column width={16}>
      <Button.Group fluid>
        <Button onClick={()=>dispatch(SetCurrencyRatio('میلیون تومان'))} color="grey" basic>میلیون</Button>
        <Button.Or />
        <Button onClick={()=>dispatch(SetCurrencyRatio('میلیارد تومان'))} color="grey" basic>میلیارد</Button>
      </Button.Group>
    </Grid.Column>

  </Grid>
}
export default SearchPriceRangePicker